<template>
  <d-container fluid>
    <d-form @submit.prevent="submit()">
      <d-row>
        <d-col sm="12" md="12" lg="9">
          <d-card>
            <h3 class="table-title m-0 p-3">Validação da medição Ruído</h3>
            <d-tabs class="custom-tabs">
              <d-tab
                v-for="(field, index) in optionFields" :key="index"
                :title="field.label"
                :active="selectedNoiseModel === field.label"
                @click="selectedNoiseModel = field.label"
                class="p-3"
              >
                <dynamic-list
                  :list="model.noise.options[field.model]"
                  :label="field.label"
                  :on-add="() => addRow(model.noise.options[field.model])"
                  :on-remove="(index) => removeRow(model.noise.options[field.model], index)"
                  :on-change="(index, row) => capitalizeInput(model.noise.options[field.model], index)"
                />
              </d-tab>
            </d-tabs>
          </d-card>
        </d-col>
      </d-row>
      <d-form-row class="mt-4">
        <d-button class="btn-primary" type="submit">Salvar</d-button>
      </d-form-row>
    </d-form>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { capitalize } from '_utils';
import SettingsService from '_services/rest/modules/settings';
import formatErrors from '_common/mixins/FormatErrors';
import { _LOAD_MODEL_VALIDATION_, MEASUREMENT_VALIDATION, OPTION, OPTION_FIELDS_NOISE } from './SettingsModel';
import DynamicList from './DynamicList.vue';

export default {
  name: 'validation-form',
  mixins: [formatErrors],
  components: {
    DynamicList,
  },
  data() {
    return {
      model: { ...MEASUREMENT_VALIDATION },
      optionFields: OPTION_FIELDS_NOISE,
      selectedNoiseModel: 'avaliation',
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    addRow(field) {
      field.push({ ...OPTION });
    },
    removeRow(field, indexToRemove) {
      if (indexToRemove > -1 && indexToRemove < field.length) {
        field.splice(indexToRemove, 1);
      }
    },
    capitalizeInput(field, index) {
      field[index].name = capitalize(field[index].name);
    },
    submit() {
      this.loading = true;
      try {
        SettingsService.saveOptions(this.model, 'validation')
          .then(() => {
            this.getSettings();
            this.activeAlert({
              message: 'Configurações salvas com sucesso',
              theme: 'success',
            });
          });
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_VALIDATION_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss">
.row-container {
  align-items: center;
  flex-wrap: nowrap;
  margin-left: 5px;
  gap: 8px;
  color: #5A6169;
}

.row-container input {
  min-width: 40px;
  color: inherit;
}

.row-container span {
  white-space: nowrap;
  color: inherit;
}

.text-input {
  min-width: 50px;
  color: inherit;
}

.bg-grey {
  background-color: #F6F6F6;
}

.table-title {
  font-size: 16px;
  font-weight: bold;
  color: #424242;
}

.custom-tabs .nav-tabs {
  padding-left: 10px;
}

.custom-tabs .nav-tabs .nav-item .active {
  background-color: #F6F6F6;
}
</style>
